module.exports = __webpack_public_path__ + "static/media/logo_DHL.bb85bacc.svg";